<template>
  <header class="site-header">
    <div class="header-container">
      <!-- 左侧logo和文字 -->
      <div class="header-left">
        <img src="../assets/logo.png" alt="logo" class="header-logo" />
        <div class="header-titles">
          <div class="header-title-cn">兰台档案研究院</div>
          <div class="header-title-en">LantaiArchives Research Institute</div>
        </div>
      </div>
      <!-- 移动端菜单按钮 -->
      <button class="mobile-menu-btn" @click="mobileMenuOpen = !mobileMenuOpen">
        <span class="menu-icon">☰</span>
      </button>
      <!-- 中间菜单 -->
      <nav :class="['header-nav', { 'mobile-open': mobileMenuOpen }]">
        <template v-if="!isInPersonalCenter">
          <router-link to="/" class="header-nav-item" exact @click.native="mobileMenuOpen = false">首页</router-link>
          <router-link to="/institute" class="header-nav-item" @click.native="mobileMenuOpen = false">研究院</router-link>
          <router-link to="/news" class="header-nav-item" @click.native="mobileMenuOpen = false">新闻动态</router-link>
          <router-link to="/project" class="header-nav-item" @click.native="mobileMenuOpen = false">项目研究</router-link>
          <router-link to="/volume" class="header-nav-item" @click.native="mobileMenuOpen = false">兰台研读</router-link>
          <router-link to="/policy" class="header-nav-item" @click.native="mobileMenuOpen = false">政策法规</router-link>
          <router-link to="/talent" class="header-nav-item" @click.native="mobileMenuOpen = false">人才招聘</router-link>
          <a href="javascript:void(0)" class="header-nav-item" @click="showCertificateDialog">查询证书</a>
          <router-link v-if="isLoggedIn" to="/profile" class="header-nav-item" @click.native="mobileMenuOpen = false">个人资料</router-link>
        </template>
        <template v-else>
          <router-link to="/" class="header-nav-item" exact @click.native="mobileMenuOpen = false">首页</router-link>
          <router-link to="/archive-course" class="header-nav-item" @click.native="mobileMenuOpen = false">档案课程</router-link>
          <router-link to="/purchased-course" class="header-nav-item" @click.native="mobileMenuOpen = false">已购课程</router-link>
          <router-link to="/grade-query" class="header-nav-item" @click.native="mobileMenuOpen = false">成绩查询</router-link>
          <router-link to="/e-certificate" class="header-nav-item" @click.native="mobileMenuOpen = false">电子证书</router-link>
          <router-link v-if="isLoggedIn" to="/profile" class="header-nav-item" @click.native="mobileMenuOpen = false">个人资料</router-link>
        </template>
        <!-- 移动端显示的服务热线和登录按钮 -->
        <div class="mobile-extra">
          <div class="service-hotline-mobile">
            <span class="hotline-icon">📞</span>
            <span>023-65031293</span>
          </div>
          <template v-if="isLoggedIn">
            <div class="user-info-mobile">
              <div>{{ userInfo ? userInfo.name : '加载中...' }}，欢迎您</div>
              <span class="logout-text-mobile" @click="handleLogout">退出登录</span>
            </div>
          </template>
          <button v-else class="login-btn-mobile" @click="showAuthDialog('login'); mobileMenuOpen = false">未登录</button>
        </div>
      </nav>
      <!-- 右侧服务热线和按钮 -->
      <div class="header-right">
        <div class="service-hotline">
          <span class="hotline-icon">📞</span>
          <div class="hotline-info">
            <div class="hotline-label">服务热线</div>
            <div class="hotline-number">023-65031293</div>
          </div>
        </div>
        <template v-if="isLoggedIn">
          <div class="user-info">
            <div class="welcome-text">
              <span class="user-name-display">{{ userInfo ? userInfo.name : '加载中...' }}</span>，欢迎您
            </div>
            <div class="user-actions">
              <span class="logout-text" @click="handleLogout">退出登录</span>
            </div>
          </div>
        </template>
        <button v-else class="login-btn" @click="showAuthDialog('login')">未登录</button>
      </div>
    </div>
    <auth-dialog :visible.sync="authDialogVisible" :initial-mode="authMode" @login-success="handleLoginSuccess" />
    
    <!-- 证书查询弹窗 -->
    <el-dialog 
      title="查询证书" 
      :visible.sync="certificateDialogVisible" 
      width="90%"
      :close-on-click-modal="false"
      custom-class="certificate-dialog"
      @close="handleCloseDialog"
    >
      <!-- 查询表单 -->
      <el-form :model="searchForm" label-width="100px" class="search-form">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="手机号">
              <el-input v-model="searchForm.phone" placeholder="请输入手机号" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="身份证号">
              <el-input v-model="searchForm.idCard" placeholder="请输入身份证号" clearable></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="姓名">
              <el-input v-model="searchForm.name" placeholder="请输入姓名" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="证书编号">
              <el-input v-model="searchForm.certificateNumber" placeholder="请输入证书编号" clearable></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="证书类型">
              <el-input v-model="searchForm.type" placeholder="请输入证书类型" clearable></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" style="text-align: center;">
            <el-button type="primary" @click="handleSearch" :loading="searchLoading">查询</el-button>
            <el-button @click="handleReset">重置</el-button>
          </el-col>
        </el-row>
      </el-form>

      <!-- 查询结果 -->
      <div v-if="certificateList.length > 0" class="result-section">
        <el-divider content-position="left">查询结果（共 {{ totalCount }} 条）</el-divider>
        <el-table 
          :data="certificateList" 
          border 
          style="width: 100%"
          max-height="400"
        >
          <el-table-column prop="name" label="姓名" width="120"></el-table-column>
          <el-table-column prop="phone" label="手机号" width="130"></el-table-column>
          <el-table-column prop="idCard" label="身份证号" width="180"></el-table-column>
          <el-table-column prop="certificateNumber" label="证书编号" width="180"></el-table-column>
          <el-table-column label="证书类型" width="120">
            <template slot-scope="scope">
              {{ certificateTypeMap[scope.row.type] || scope.row.type || '-' }}
            </template>
          </el-table-column>
          <el-table-column label="课程方向" width="150">
            <template slot-scope="scope">
              {{ courseDirectionMap[scope.row.courseDirection] || scope.row.courseDirection || '-' }}
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="创建时间" width="180"></el-table-column>
          <el-table-column label="证书图片" width="120" fixed="right">
            <template slot-scope="scope">
              <el-button 
                type="text" 
                size="small" 
                @click="viewCertificate(scope.row)"
                v-if="scope.row.certificateUrl"
              >
                查看
              </el-button>
              <span v-else>-</span>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 没有查询结果 -->
      <div v-else-if="hasSearched && !searchLoading" class="no-result">
        <el-empty description="未查询到相关证书信息"></el-empty>
      </div>
    </el-dialog>

  </header>
</template>

<script>
import AuthDialog from './AuthDialog.vue'
import { getCertificateOtherImgWx } from '../api/website'

export default {
  name: 'SiteHeader',
  components: {
    AuthDialog
  },
  data() {
    return {
      authDialogVisible: false,
      authMode: 'login', // 'login' or 'register'
      mobileMenuOpen: false, // 移动端菜单开关
      // 证书查询相关
      certificateDialogVisible: false,
      searchForm: {
        phone: '',
        idCard: '',
        name: '',
        certificateNumber: '',
        type: ''
      },
      certificateList: [],
      totalCount: 0,
      searchLoading: false,
      hasSearched: false,
      // 课程方向映射
      courseDirectionMap: {
        '1': '默认',
        '2': '监控',
        '3': '维保',
        '4': '三级',
        '5': '四级',
        '6': '五级'
      },
      // 证书类型映射
      certificateTypeMap: {
        '1': '结业'
      }
    }
  },
  computed: {
    isLoggedIn() {
      return this.$store.state.isLoggedIn
    },
    userInfo() {
      return this.$store.state.userInfo
    },
    isInPersonalCenter() {
      return this.$store.state.isInPersonalCenter
    }
  },
  created() {
    // 如果已登录但没有用户信息，则获取用户信息
    if (this.isLoggedIn && !this.userInfo) {
      this.$store.dispatch('fetchUserInfo')
    }
  },
  methods: {
    showAuthDialog(mode) {
      if (!this.isLoggedIn || mode === 'register') {
        this.authMode = mode
        this.authDialogVisible = true
      }
    },
    handleLoginSuccess() {
      // 登录状态已经在 Vuex 中更新，不需要额外处理
    },
    async handleLogout() {
      try {
        await this.$confirm('确认退出登录吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        this.$store.dispatch('logout')
        this.$router.push('/')
        this.$message.success('已退出登录')
      } catch (error) {
        // 用户取消退出
      }
    },
    togglePersonalCenter() {
      this.$store.dispatch('setPersonalCenterMode', !this.isInPersonalCenter)
      if (!this.isInPersonalCenter) {
        this.$router.push('/')
      }
    },
    // 证书查询相关方法
    showCertificateDialog() {
      this.certificateDialogVisible = true
      this.mobileMenuOpen = false
    },
    handleCloseDialog() {
      this.handleReset()
    },
    async handleSearch() {
      // 检查是否至少填写了一个查询条件
      const hasCondition = Object.values(this.searchForm).some(value => value && value.trim())
      if (!hasCondition) {
        this.$message.warning('请至少填写一个查询条件')
        return
      }

      this.searchLoading = true
      this.hasSearched = false
      
      try {
        // 构建查询参数（只传有值的参数）
        const params = {}
        Object.keys(this.searchForm).forEach(key => {
          if (this.searchForm[key] && this.searchForm[key].trim()) {
            params[key] = this.searchForm[key].trim()
          }
        })

        const response = await getCertificateOtherImgWx(params)
        
        if (response.code === 0 || response.code === 200) {
          this.certificateList = response.rows || []
          this.totalCount = response.total || 0
          this.hasSearched = true
          
          if (this.certificateList.length === 0) {
            this.$message.info('未查询到相关证书信息')
          } else {
            this.$message.success(`查询成功，共找到 ${this.totalCount} 条记录`)
          }
        } else {
          this.$message.error(response.msg || '查询失败')
          this.certificateList = []
          this.totalCount = 0
          this.hasSearched = true
        }
      } catch (error) {
        console.error('查询证书失败:', error)
        this.$message.error('查询失败，请稍后重试')
        this.certificateList = []
        this.totalCount = 0
        this.hasSearched = true
      } finally {
        this.searchLoading = false
      }
    },
    handleReset() {
      this.searchForm = {
        phone: '',
        idCard: '',
        name: '',
        certificateNumber: '',
        type: ''
      }
      this.certificateList = []
      this.totalCount = 0
      this.hasSearched = false
    },
    viewCertificate(row) {
      if (row.certificateUrl) {
        // 直接在新窗口打开证书文件（支持PDF和图片）
        window.open(row.certificateUrl, '_blank')
      }
    }
  }
}
</script>

<style scoped>
.site-header {
  background: #3c4a6b;
  color: #fff;
  border-radius: 10px 10px 0 0;
  padding: 0;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.header-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 70px;
  max-width: 100vw;
  padding: 0 24px;
  margin: 0 20px;
}

.header-left {
  display: flex;
  align-items: center;
  min-width: 260px;
}

.header-logo {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: #fff;
  object-fit: contain;
  margin-right: 12px;
  border: 2px solid #fff;
}

.header-titles {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.header-title-cn {
  font-size: 20px;
  font-weight: 600;
  letter-spacing: 1px;
  color: #fff;
}

.header-title-en {
  font-size: 13px;
  color: #e6e6e6;
  font-weight: 500;
  margin-top: 2px;
}

.header-nav {
  display: flex;
  flex: 1;
  justify-content: center;
  gap: 24px;
  margin: 0 15px;
}

.header-nav-item {
  color: #fff;
  font-size: 15px;
  text-decoration: none;
  padding: 0 6px;
  transition: all 0.2s;
  font-weight: 400;
  white-space: nowrap;
}

.header-nav-item.router-link-active,
.header-nav-item:hover {
  color: #fff;
  font-weight: 600;
  border-bottom: 2px solid #fff;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 260px;
  justify-content: flex-end;
}

.service-hotline {
  display: flex;
  align-items: center;
  background: none;
  color: #fff;
  margin-right: 4px;
}

.hotline-icon {
  font-size: 18px;
  margin-right: 4px;
  margin-top: 2px;
}

.hotline-info {
  display: flex;
  flex-direction: column;
  line-height: 1.1;
}

.hotline-label {
  font-size: 13px;
  font-weight: 600;
  color: #fff;
}

.hotline-number {
  font-size: 16px;
  font-weight: 500;
  color: #fff;
}

.login-btn {
  background: #fe6c6f;
  color: #fff;
  border: none;
  border-radius: 6px;
  padding: 8px 24px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.2s;
}

.login-btn:hover {
  background: #ff4d4f;
}

.user-info {
  background: #3c4a6b;
  border-radius: 6px;
  padding: 5px 12px;
  display: flex;
  flex-direction: column;
  color: #fff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.user-name-display {
  font-weight: 600;
}

.welcome-text {
  font-size: 16px;
  margin-bottom: 0px;
  line-height: 1.1;
  white-space: nowrap;
  width: 100%;
  text-align: right;
}

.logout-text {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.5);
  text-decoration: underline;
  cursor: pointer;
  line-height: 1.1;
  width: 100%;
  text-align: center;
}

.logout-text:hover {
  color: #fff;
}

.user-actions {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-top: 4px;
}

.personal-center {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.5);
  cursor: pointer;
  text-decoration: underline;
}

.personal-center:hover {
  color: #fff;
}

.divider {
  color: rgba(255, 255, 255, 0.5);
  font-size: 14px;
}

.switch-mode {
  cursor: pointer;
  color: #fff;
  font-size: 15px;
  padding: 0 6px;
  transition: all 0.2s;
  font-weight: 400;
}

.switch-mode:hover {
  color: #fff;
  font-weight: 600;
  border-bottom: 2px solid #fff;
}

.user-actions {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 4px;
}

.logout-text {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.5);
  text-decoration: underline;
  cursor: pointer;
  line-height: 1.1;
}

.logout-text:hover {
  color: #fff;
}

/* 移动端适配 */
.mobile-menu-btn {
  display: none;
  background: none;
  border: none;
  color: #fff;
  font-size: 28px;
  cursor: pointer;
  padding: 5px 10px;
}

.mobile-extra {
  display: none;
}

@media screen and (max-width: 768px) {
  .site-header {
    border-radius: 0;
  }

  .header-container {
    height: 60px;
    margin: 0;
    padding: 0 15px;
    position: relative;
  }

  .header-left {
    min-width: auto;
    flex: 1;
  }

  .header-logo {
    width: 40px;
    height: 40px;
    margin-right: 10px;
  }

  .header-title-cn {
    font-size: 16px;
  }

  .header-title-en {
    font-size: 11px;
  }

  .mobile-menu-btn {
    display: block;
    z-index: 1001;
  }

  .header-nav {
    position: fixed;
    top: 60px;
    left: -100%;
    width: 100%;
    height: calc(100vh - 60px);
    background: #3c4a6b;
    flex-direction: column;
    justify-content: flex-start;
    align-items: stretch;
    gap: 0;
    margin: 0;
    padding: 20px 0;
    transition: left 0.3s ease;
    z-index: 1000;
    overflow-y: auto;
  }

  .header-nav.mobile-open {
    left: 0;
  }

  .header-nav-item {
    padding: 15px 20px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    font-size: 16px;
  }

  .header-nav-item.router-link-active,
  .header-nav-item:hover {
    background: rgba(255, 255, 255, 0.1);
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  }

  .header-right {
    display: none;
  }

  .mobile-extra {
    display: flex;
    flex-direction: column;
    gap: 15px;
    padding: 20px;
    margin-top: 20px;
    border-top: 1px solid rgba(255, 255, 255, 0.1);
  }

  .service-hotline-mobile {
    display: flex;
    align-items: center;
    gap: 8px;
    color: #fff;
    font-size: 16px;
    padding: 10px 0;
  }

  .user-info-mobile {
    display: flex;
    flex-direction: column;
    gap: 10px;
    color: #fff;
    padding: 10px 0;
  }

  .logout-text-mobile {
    color: rgba(255, 255, 255, 0.7);
    text-decoration: underline;
    cursor: pointer;
    font-size: 14px;
  }

  .login-btn-mobile {
    background: #fe6c6f;
    color: #fff;
    border: none;
    border-radius: 6px;
    padding: 12px 24px;
    font-size: 16px;
    font-weight: 500;
    cursor: pointer;
    transition: background 0.2s;
  }

  .login-btn-mobile:hover {
    background: #ff4d4f;
  }
}

/* 证书查询弹窗样式 */
.search-form {
  margin-bottom: 20px;
}

.result-section {
  margin-top: 30px;
}

.no-result {
  margin-top: 30px;
  padding: 40px 0;
  text-align: center;
}
</style>

<style>
/* 全局样式 - 证书弹窗 */
.certificate-dialog {
  max-width: 1200px;
}

.certificate-dialog .el-dialog__body {
  max-height: 70vh;
  overflow-y: auto;
}

@media screen and (max-width: 768px) {
  .certificate-dialog {
    width: 95% !important;
  }
  
  .certificate-dialog .el-form-item {
    margin-bottom: 15px;
  }
  
  .certificate-dialog .el-table {
    font-size: 12px;
  }
}
</style>